import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "zone-content" }
const _hoisted_2 = { key: 1 }

import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import MZoneSelection from '@/modules/MZoneSelection.vue'
import CZoneSelectionInfo from '@/components/CZoneSelectionInfo.vue'
import CZoneAnnouncement from '@/components/CZoneAnnouncement.vue'
import { ERROR_CODES } from '@/model/ErrorCodes'
import { track } from '@/lib/track'


export default /*@__PURE__*/_defineComponent({
  __name: 'ZoneOverviewView',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()
const show = ref(false)

const announcementId = computed(() => {
  return store.state.announcement
})

const zones = computed(() => {
  return store.getters.zoneTeasers
})

onMounted(() => {
  // make sure when the view is loaded that we reset the tournaments state
  // if not we will have problems with the MWinningDistribution.vue
  store.commit('resetActiveTournament')
  store
    .dispatch('fetchZoneTeasers')
    .then(() => {
      show.value = true
    })
    .catch((err: any) => {
      if (err && err.errorCode === 401) {
        router.replace('/extern/login')
      } else {
        console.log('error zone overview', err)
        router.push({ path: '/error/' + (err && err.errorCode) || ERROR_CODES.UNKNOWN + '' })
      }
    })
  track({
    id: 'zone-overview-enter',
    path: route.fullPath,
  })
})

return (_ctx: any,_cache: any) => {
  const _component_t_container = _resolveComponent("t-container")!
  const _component_c_loading_indicator = _resolveComponent("c-loading-indicator")!
  const _component_t_content = _resolveComponent("t-content")!

  return (_openBlock(), _createBlock(_component_t_content, { main: "" }, {
    default: _withCtx(() => [
      _createVNode(CZoneSelectionInfo),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_t_container, null, {
          default: _withCtx(() => [
            (announcementId.value)
              ? (_openBlock(), _createBlock(CZoneAnnouncement, {
                  key: 0,
                  announcementId: announcementId.value
                }, null, 8, ["announcementId"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_c_loading_indicator, {
          show: !show.value
        }, null, 8, ["show"]),
        (show.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (zones.value.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(zones.value, (zoneTeaserUi, idx) => {
                    return (_openBlock(), _createBlock(MZoneSelection, {
                      class: "zone-selection",
                      key: `${zoneTeaserUi.zoneId}_${idx}`,
                      "zone-teaser-ui": zoneTeaserUi
                    }, null, 8, ["zone-teaser-ui"]))
                  }), 128))
                : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('zoneSelection.main.tournaments_not_available')), 1))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})